import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { UpdateAdminType } from 'domain/usecases/update-admin-type';
import { RemoteUpdateAdminType } from 'data/usecases/update-admin-type';

export const makeRemoteUpdateAdminType = (): UpdateAdminType => {
  return new RemoteUpdateAdminType(makeApiUrl('/users/update-admin-type'), makeAuthorizeHttpClientDecorator());
};
